import React, { useEffect, useState } from 'react';
import { Paper, Alert } from '@mui/material';
import { Box } from '@mui/system';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { display } from '../../redux/reducers/sidebar';
import { settingsClose } from '../../redux/reducers/companySkipSave';
import TotalAmountLabels from './Components/TotalAmountLabels';
import EntryTable from './Components/EntryTable';
import { showErrorSnackbar, showWarningSnackbar } from '../../components/snackBar/snakbar';
import { showSuccessSnackbar } from '../../components/snackBar/snakbar';
import InvoiceBasicDetails from './Components/InvoiceBasicDetails';
import PaymentDetails from './Components/PaymentDetails';
import DispatchDetails from './Components/DispatchDetails';
import MultiFileAttachment from './Components/MultiFileAttachment';
import Description from './Components/Description';
import Grid from '@mui/material/Grid';

import { API, graphqlOperation } from 'aws-amplify';
import HsnandJournalTab from './Components/HsnandJournalTab';

import {
  createCrDrNoteTransactionsArray,
  createTransactionWithSpecificTime,
  deleteTransactionMaster,
  getCrDrNoteMaster,
  getMinMaxInvoiceDate,
} from '../../graphql';
import './Components//Invoice.css';
import Loader from './Components/Loader';
import { DebitNotePrint, PurchaseTaxablePrint, SalesTaxablePrint } from '../../library/InvoicePrint';
import { ShareModal } from '../../components/modals/Share';
import printJS from 'print-js';
import ConfirmCancel from '../../components/modals/confirmCancel';
import axios from 'axios';
import { uploadToServer } from '../../library/upload';
import PreviewSalesTaxable from '../../components/modals/PreviewSalesTaxable';
import DraggableAction from '../../components/Buttons/DraggableAction';
import InvoiceCancel from '../../components/modals/InvoiceCancel';
import useSaveShortcut from '../../hooks/useSaveShortcut';
import { setNavigationBlocked } from '../../redux/reducers/controllNavigation';
import { useListGeneralSettingQuery, VoucherSettingsApi } from '../../redux/apis/newVoucherSettings.api';
import { CreateCrDrBatch } from '../../graphql/postgress_graphql/customMutations';
import { useCreatePdfMutation } from '../../redux/apis/createPdf.api';
import { useStateList } from './Components/HandleInvoiceStateProvider';
import { dashboardApi } from '../../redux/apis/dashboardApi';
import UseVoucherDetails from './Components/UseVoucherDetails';
import { fetchAndPrintPDF } from '../../utils/common';
import moment from 'moment';
import API_ENDPOINTS from '../../apiEndpoints';
import useControlledNavigation from '../../hooks/useControlledNavigation';
import CancelUI from '../../components/Ui/CancelUI';
import { updateTitle } from '../../redux/reducers/titleSlice';
import { logBase } from '@syncfusion/ej2-react-charts';
import { CheckVoucherValid } from './Components/CheckVoucherValid';
import { useListCompanyPreferenceQuery } from '../../redux/apis/companyPreference.api';
let today = new Date();
let yy = today.getFullYear();
let mm = today.getMonth() + 1;
let dd = today.getDate();

if (dd < 10) dd = '0' + dd;
if (mm < 10) mm = '0' + mm;

const todayDate = yy + '-' + mm + '-' + dd;

function NewDebitNotePrime({ isVoucher, accountDetails }) {
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const navigate = useControlledNavigation();
  let location = useLocation();
  const { getVoucherDetails } = UseVoucherDetails();
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  let companyType = getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;
  const params = location.state || {
    id: parseInt(new URLSearchParams(window.location.search).get('transaction')),
    view: parseInt(new URLSearchParams(window.location.search).get('transaction')) ? true : false,
    pdflink: new URLSearchParams(window.location.search).get('pdflink') || '',
  };
  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);
   const { data: companyPreference } = useListCompanyPreferenceQuery();
      const postingDatePref = companyPreference?.find(
        (p) => p.attributetypecd === 'MyPostingDate' && String(p?.additionalvalue ?? '') === String(userPreferece?.financialYear?.financialyearid ?? '')
      );
const currentPostingDate = postingDatePref?.attributevalue;
            const [savedPostingDate,setSavedPostingDate]=useState("");
  let path = `${userPreferece?.financialYear?.companyid}/${userPreferece?.financialYear?.companybranchid}/${userPreferece?.financialYear?.financialyearid}/`;
  
  const { data: generalSettings } = useListGeneralSettingQuery(
      {
        entrytypecd: 'DebitInvoice',
        financialyearid: userPreferece?.financialYear?.financialyearid,
      },
      {
        refetchOnMountOrArgChange: true,
      }
    );
    const voucherFlag = generalSettings?.find((item) => item.expiredtimestamp === 0)?.nextinvoicenumber;
  const {
    initialState,
    setInitialState,
    data,
    setData,
    cancelModal,
    setCancelModal,
    state,
    setState,
    cancelModalStatus,
    setCancelModalStatus,
    itemData,
    setItemData,
    deleteModalStatus,
    setDeleteModalStatus,
    viewMode,
    setViewMode,
    setPaymentAccordion,
    invoiceEntry,
    setInvoiceEntry,
    totTaxAmt,
    totDiscount,
    totGSTCess,
    totNetAmt,
    totGST,
    totAmt,
    companyState,
    netAmountToPay,
    companyData,
    partyDeliveryAddressEntity,
    partyBillAddressEntity,
    invTransArr,
    paymentTransArr,
    itemsRows,
    initialAttachments,
    transGeneralSettingsFlag,
    partyAccountID,
    voucherArr,
    transVoucherArr,
    paymentTransID,
    currentVoucherNo,
    backdropOpen,
    setBackdropOpen,
    units,
    position,
    setPosition,
    isDragging,
    setIsDragging,
    offset,
    setOffset,
    registrationType,
    setTabValue,
    setItemValid,
    setNonItemValid,
    partyType,
    tableErrArr,
    setTableErrArr,
    items,
    setItems,
    nonItems,
    setNonItems,
    billingAddressDetails,
    deliveryAddressDetails,
    initItemTableDta,
    initNonItemTableData,
    previewSalesTaxableModal,
    setPreviewSalesTaxableModal,
    aTags,
    setATags,
    deletedItems,
    deletedNonItems,
    currentDouments,
    resetData,
    resetItems,
    resetNonItems,
    setItemsRows,
    setNextInvoiceDate,
    setFirstInvoiceDate,
    setLastInvoiceDate,
    firstInvoiceDate,
    lastInvoiceDate,
    nextInvoiceDate,
  } = useStateList();

  function isEmptyDeliveryAddress(details) {
    const { deliveryAddress, states, district, country, pincode, stateCD, countryCD, districtCD, gstin, customerName } = details;

    const isEmptyVal = (val) => {
      if (val === null || val === undefined) return true;
      if (typeof val === 'string') return val.trim() === '' || val === '0';
      if (typeof val === 'object') {
        return Object.values(val).every((v) => v === '' || v === null || v === undefined || v === '0');
      }
      return false;
    };

    return (
      isEmptyVal(deliveryAddress) &&
      isEmptyVal(states?.value) &&
      isEmptyVal(district?.value) &&
      isEmptyVal(country?.value) &&
      isEmptyVal(pincode) &&
      isEmptyVal(stateCD) &&
      isEmptyVal(countryCD) &&
      isEmptyVal(districtCD) &&
      isEmptyVal(gstin) &&
      isEmptyVal(customerName)
    );
  }

  const isEmptyInvDeliveryAddress = isEmptyDeliveryAddress(deliveryAddressDetails);
  const isConsigneeEmpty = data?.consigneeName === '' || data?.consigneeGST === '';
  const isEmptyPartyDelivery =
    !partyDeliveryAddressEntity ||
    (Object.keys(partyDeliveryAddressEntity).length === 0 && partyDeliveryAddressEntity.constructor === Object);
  const isAdrressEmpty = !isEmptyInvDeliveryAddress || !isEmptyPartyDelivery || !isConsigneeEmpty;
  const newItemObj = {
    itemCode: { label: '', value: '' },
    name: { label: '', value: '' },
    priceType: { label: '', value: '' },
    ledgerAccount: { label: '', value: '' },
    HSN: {
      label: '',
      value: '',
      companyID: '',
      hsnID: '',
      codeType: '',
      description: '',
    },
    qty: 0,
    units: '',
    rate: 0,
    amount: 0,
    dicount: 0,
    taxableAMount: 0,
    GSTRate: '',manualGSTFlag:0,
    taxability: { label: '', value: '' },
    manualDiscount: false,
    manualCess: false,
    autoCess: 0,
    autoDiscount: 0,
    IGST: 0,
    expiredtimestamp: 0,
    CGST: '0.00',
    SGST: '0.00',
    GSTCess: 0,
    netAmount: '0000',
    editable: true,
    new: true,
  };
  const newNonItemObj = {
    ledgerAccount: { label: '', value: '' },
    HSN: {
      label: '',
      value: '',
      companyID: '',
      hsnID: '',
      codeType: '',
      description: '',
    },
    description: '',
    taxableAMount: 0,
    GSTRate: '',manualGSTFlag:0,
    taxability: { label: '', value: '' },
    manualDiscount: false,
    manualCess: false,
    autoCess: 0,
    autoDiscount: 0,
    IGST: 0,
    expiredtimestamp: 0,
    CGST: '0.00',
    SGST: '0.00',
    GSTCess: 0,
    netAmount: 0,
    editable: true,
    new: true,
  };
  dispatch(display());

  const { Enable_AutoPayReminder, Enable_AutoReminderDays, Enable_CreditLimit, Enable_CreditPeriod, Enable_ItemWiseEntry } = useSelector(
    (state) => state.paymentSettingsReducer
  );
  const InvoiceSettings = useSelector((state) => state.invoiceSettingsReducer)?.Regular;

  const [AttachmentToBeDeleted, setAttachmentToBeDeleted] = useState([]);
  const startDrag = (e) => {
    setIsDragging(true);
    setOffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    });
  };

  const endDrag = () => setIsDragging(false);
  useEffect(() => {
    const onDrag = (e) => {
      if (!isDragging) return;
      let newY = e.clientY - offset.y;
      let newX = e.clientX - offset.x;
      newY = Math.max(300, newY);
      newY = Math.min(640, newY);
      newX = Math.max(100, newX);
      newX = Math.min(1445, newX);
      setPosition((prevPosition) => ({
        ...prevPosition,
        y: newY,
        x: newX,
      }));
    };

    if (isDragging) {
      window.addEventListener('mousemove', onDrag);
      window.addEventListener('mouseup', endDrag);
      return () => {
        window.removeEventListener('mousemove', onDrag);
        window.removeEventListener('mouseup', endDrag);
      };
    }
  }, [isDragging, offset.x, offset.y]);
  const { saveSkipStatus } = useSelector((state) => state.companySipSaveReducer);
  useEffect(() => {
    if (saveSkipStatus == false) {
      dispatch(settingsClose());
      navigate('/companysetup');
    }
  }, []);
  // exit
  let [modalOpen, setModalOpen] = useState(false);
  let saveV = true;
  function deepEqual(obj1, obj2) {
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
      return obj1 === obj2;
    }

    let keys1 = Object.keys(obj1);
    let keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    // Check if all keys and values are the same
    for (let key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        console.log(key, obj1[key], '//', obj2[key]);
        return false;
      }
    }

    return true;
  }
  let selector = useSelector((state) => state.sidebarReducer?.SideBarOpts);
  let selectorDrawer = useSelector((state) => state.sidebarReducer);

  useEffect(() => {
    setATags(document.getElementsByTagName('a').length);
    if (selectorDrawer == true) {
      setTimeout(() => {
        setATags(document.getElementsByTagName('a').length);
      }, 50);
    }
  }, [selectorDrawer, selector]);

  // useEffect(() => {
  //   if (
  //     !deepEqual(data, initialState) ||
  //     itemsRows.length !== initialAttachments.length
  //   ) {
  //     handleNavigationBlocker(true);
  //   }
  //   if (itemsRows.length === initialAttachments.length) {
  //     itemsRows.map((e, index) => {
  //       handleNavigationBlocker(true);
  //     });
  //   }
  //   return () => {
  //     handleNavigationBlocker(false);
  //   };
  // }, [data, aTags]);

  // const handleNavigationBlocker = (value) => {
  //   dispatch(setNavigationBlocked(value));
  // };

  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    if (data?.voucherNumber) {
      dispatch(updateTitle(data.voucherNumber));
    }
    if (params.view) return;
    const isDataModified = JSON.stringify(data) !== JSON.stringify(initialState);
    const isAttachmentsModified = itemsRows.length !== initialAttachments.length;
    const shouldBeDirty = isDataModified || isAttachmentsModified;

    if (shouldBeDirty !== isDirty) {
      setIsDirty(shouldBeDirty);
    }
  }, [data, itemsRows, initialState, initialAttachments, isDirty]);

  useEffect(() => {
    dispatch(setNavigationBlocked(isDirty));
  }, [isDirty, dispatch]);

  function formVaidation(objData) {
    //DebitNote Prome
    let isvalid = true;
    let errorArr = [];

    let obj = { ...data };
    Object.keys(objData).map((itemKey) => {
      if (itemKey === 'partyName') {
        if (objData[itemKey]?.label == '') {
          isvalid = false;
          obj.errorFields.partyName = 'Customer/Supplier name is required';
          obj.errorStatus.partyName = true;
          errorArr.push('Customer/Supplier');
        } else {
          obj.errorFields.partyName = '';
          obj.errorStatus.partyName = false;
        }
      }

      if (itemKey === 'seriesVouchers') {
        if (objData[itemKey]?.value === '') {
          isvalid = false;
          obj.errorFields.seriesVouchers = 'Debit Note Series Name is Required';
          obj.errorStatus.seriesVouchers = true;
          errorArr.push('Debit Note Series Name');
        } else {
          obj.errorFields.seriesVouchers = '';
          obj.errorStatus.seriesVouchers = false;
        }
      }

      if (itemKey === 'invoiceDate') {
        const startDate = userPreferece.financialYear.startdate * 1000;
        const endDate = userPreferece.financialYear.enddate * 1000;

        const minDate = moment(params?.id && !isNaN(params.id) ? firstInvoiceDate || startDate : firstInvoiceDate || startDate);

        const maxDate = moment(params?.id && !isNaN(params.id) ? nextInvoiceDate || endDate : endDate);

        if (!objData[itemKey]?.trim()) {
          isvalid = false;
          obj.errorFields.invoiceDate = 'Debit Note Date is required';
          obj.errorStatus.invoiceDate = true;
          errorArr.push('Debit Note Date');
        } else if (moment(objData[itemKey], 'YYYY-MM-DD').isBefore(minDate) || moment(objData[itemKey], 'YYYY-MM-DD').isAfter(maxDate)) {
          isvalid = false;
          obj.errorFields.invoiceDate = `Invoice Date must be between ${minDate.format('DD MMM YYYY')} and ${maxDate.format(
            'DD MMM YYYY'
          )}`;
          showWarningSnackbar(`Invoice Date must be between ${minDate.format('DD MMM YYYY')} and ${maxDate.format('DD MMM YYYY')}`);
          obj.errorStatus.invoiceDate = true;
        } else {
          obj.errorFields.invoiceDate = '';
          obj.errorStatus.invoiceDate = false;
        }
      }

      if (registrationType != 1) {
        if (itemKey === 'taxability') {
          if (objData[itemKey].value === '') {
            isvalid = false;
            obj.errorFields.taxability = 'Taxability is required';
            obj.errorStatus.taxability = true;
            errorArr.push('Taxability');
          } else {
            obj.errorFields.taxability = '';
            obj.errorStatus.taxability = false;
          }
        }
      }

      if (itemKey === 'paymentType') {
        if (objData[itemKey]?.trim()?.length <= 0) {
          isvalid = false;
          obj.errorFields.paymentType = 'Payment Type is Required';
          obj.errorStatus.paymentType = true;
        } else {
          obj.errorFields.paymentType = '';
          obj.errorStatus.paymentType = false;
        }
      }

      if (itemKey === 'receivedAmount') {
        if (objData['paymentType'] == 'Cash' || objData['paymentType'] == 'Bank') {
          if (objData[itemKey] == 0 || isNaN(Number(objData[itemKey]))) {
            isvalid = false;
            obj.errorFields.receivedAmount = 'Received Amount is Required';
            obj.errorStatus.receivedAmount = true;
            setPaymentAccordion(true);
          } else if (Number(netAmountToPay) < Number(data.receivedAmount)) {
            isvalid = false;
            obj.errorFields.receivedAmount = 'Amount should be less than Grand Total';
            obj.errorStatus.receivedAmount = true;
            setPaymentAccordion(true);
          } else {
            obj.errorFields.receivedAmount = '';
            obj.errorStatus.receivedAmount = false;
          }
        }
      }

      if (itemKey === 'receivedAccount') {
        if (objData['paymentType'] == 'Cash' || objData['paymentType'] == 'Bank') {
          if (objData[itemKey].value == '') {
            isvalid = false;
            obj.errorFields.receivedAccount = 'Received Account is Required';
            obj.errorStatus.receivedAccount = true;
            setPaymentAccordion(true);
          } else {
            obj.errorFields.receivedAccount = '';
            obj.errorStatus.receivedAccount = false;
          }
        }
      }

      if (itemKey === 'creditPeriod') {
        if (objData['paymentType'] == 'Credit') {
          if (objData[itemKey] > 1000 || objData[itemKey] < 0) {
            isvalid = false;
            obj.errorFields.creditPeriod = 'Credit period should between 0 and 1000';
            obj.errorStatus.creditPeriod = true;
            showWarningSnackbar('Credit period should between 0 and 1000');
            setPaymentAccordion(true);
          } else {
            obj.errorFields.creditPeriod = '';
            obj.errorStatus.creditPeriod = false;
          }
        }
      }

      if (itemKey === 'adjustments') {
        if (!new RegExp(/^[+-]?(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(objData[itemKey]) && objData[itemKey]?.trim()?.length > 0) {
          isvalid = false;
          obj.errorFields.adjustments = 'Invalid Amount Format';
          obj.errorStatus.adjustments = true;
        } else {
          obj.errorFields.adjustments = '';
          obj.errorStatus.adjustments = false;
        }
      }

      if (itemKey === 'placeOfSupply') {
        if (objData[itemKey].value?.length <= 0) {
          isvalid = false;
          obj.errorFields.placeOfSupply = 'Place Of Supply is Required';
          obj.errorStatus.placeOfSupply = true;
          errorArr.push('Place Of Supply');
        } else {
          obj.errorFields.placeOfSupply = '';
          obj.errorStatus.placeOfSupply = false;
        }
      }
      if (itemKey === 'currencyRate') {
        if (objData[itemKey] === 0 || objData[itemKey] === '') {
          isvalid = false;
          obj.errorStatus.currencyRate = true;
          setTabValue('2');
          showWarningSnackbar('Please enter the Currency Rate');
        } else {
          obj.errorFields.currencyRate = '';
          obj.errorStatus.currencyRate = false;
        }
      }

      if (itemKey === 'bankReferenceNo') {
        if (objData['paymentType'] === 'Bank') {
          if (!new RegExp(/^\d{9,18}$/).test(objData[itemKey]) && objData[itemKey].trim().length > 0) {
            isvalid = false;
            obj.errorFields.bankReferenceNo = 'Invalid Bank/UPI Reference number';
            obj.errorStatus.bankReferenceNo = true;
          } else {
            obj.errorFields.bankReferenceNo = '';
            obj.errorStatus.bankReferenceNo = false;
          }
        }
      }
      if(Number(voucherFlag)===-1){
      if (itemKey === 'voucherNumber') {
        const { valid, message } = CheckVoucherValid(objData[itemKey],'Debit Note Number');
        if (objData[itemKey].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.voucherNumber = 'Debit Note Number is Required';
          obj.errorStatus.voucherNumber = true;
        }else if(!valid){
                                   isvalid = false;
                                  obj.errorFields.voucherNumber =message;
                                  obj.errorStatus.voucherNumber = true;
                                  showWarningSnackbar(message);
                                }
                                 else {
          let valid = true;
          voucherArr.map((ele) => {
            if (ele.InvoiceNumber !== invoiceEntry.InvoiceNumber) {
              if (ele.VoucherNumber === data.voucherNumber) {
                valid = false;
              }
            }
          });
          if (valid == false) {
            isvalid = false;
            obj.errorFields.voucherNumber = 'Debit Note Number already exists';
            obj.errorStatus.voucherNumber = true;
          } else {
            obj.errorFields.voucherNumber = '';
            obj.errorStatus.voucherNumber = false;
          }
        }
      }
    }
    

      if (data.paymentType !== 'Credit') {
        if (itemKey === 'transactionVoucher') {
          if (objData[itemKey].trim().length <= 0) {
            isvalid = false;
            obj.errorFields.transactionVoucher = 'Voucher Number is Required';
            obj.errorStatus.transactionVoucher = true;
          } else {
            let valid = true;
            transVoucherArr.map((ele) => {
              if (ele.VoucherNumber !== currentVoucherNo)
                if (ele.VoucherNumber === data.transactionVoucher) {
                  valid = false;
                }
            });

            if (valid == false) {
              isvalid = false;
              obj.errorFields.transactionVoucher = 'Voucher Number already exists';
              obj.errorStatus.transactionVoucher = true;
            } else {
              obj.errorFields.transactionVoucher = '';
              obj.errorStatus.transactionVoucher = false;
            }
          }
        }
      }

      if (itemKey === 'remarks') {
        if (objData[itemKey]?.trim()?.length > 250 && objData[itemKey]?.trim()?.length > 0) {
          isvalid = false;
          obj.errorFields.remarks = 'Description must be less than 250 characters';
          obj.errorStatus.remarks = true;
        } else {
          obj.errorFields.remarks = '';
          obj.errorStatus.remarks = false;
        }
      }
    });

    setData(obj);
    const validErrors = errorArr.filter((e) => !!e && e.trim?.().length > 0);

    if (!isvalid) {
      if (validErrors.length === 1) {
        showWarningSnackbar(`${validErrors[0]} is required`);
      } else if (validErrors.length > 1) {
        const lastField = validErrors.pop();
        const errorText = `${validErrors.join(', ')} and ${lastField} are required`;
        showWarningSnackbar(errorText);
      }
    }
    if (isvalid) {
      if (Number(totTaxAmt + totGST + totGSTCess) > 99999999999) {
        showWarningSnackbar(`Total Net Amount must be less than ${data?.currency?.sign}1,000 crore.`);
        isvalid = false;
      }
    }
    return isvalid;
  }
  function checkPriceTypeWithInvDate(value) {
    const updatedTableArr = [...items];
    let isValid = true;

    const momentInvoiceDate = moment(value, 'YYYY-MM-DD');
    updatedTableArr.forEach((subele) => {
      if (subele?.effectiveFrom !== 0) {
        const tempEffectiveFrom = moment(subele.effectiveFrom * 1000).startOf('day');
        const tempEffectiveTo =
          subele.effectiveTo === '' || subele?.effectiveTo === 0 ? null : moment(subele.effectiveTo * 1000).startOf('day');

        const normalizedInvoiceDate = moment(momentInvoiceDate).startOf('day');
        const isOutsideRange =
          normalizedInvoiceDate.isBefore(tempEffectiveFrom) || (tempEffectiveTo && normalizedInvoiceDate.isAfter(tempEffectiveTo));

        if (isOutsideRange) {
          isValid = false;
          subele.invalidDate = true;
        } else {
          subele.invalidDate = false;
        }
      }
    });

    if (!isValid) {
      showWarningSnackbar('The highlighted items do not match the invoice date range. Please verify the effective dates.');
    }
    return isValid;
  }
  async function getInvoiceMasterData(data) {
    try {
      setBackdropOpen(true);
      const res = await API.graphql(graphqlOperation(getCrDrNoteMaster, { crdrnoteid: data }));
      if (res.data.getCrDrNoteMaster !== null) {
        setInvoiceEntry(res.data.getCrDrNoteMaster?.[0]);
           const invDate=  res.data.getCrDrNoteMaster?.[0].crdrnotedate;
                      setSavedPostingDate(invDate);
        // setBackdropOpen(false);
      }else{
         setSavedPostingDate("");
        setData((prev)=>({
          ...prev,
          invoiceDate:""

        }));
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }
  async function getLatestCrDrNote() {
  try {
    const res = await API.graphql(
      graphqlOperation(getMinMaxInvoiceDate, {
        serialnumber: data?.seriesVouchers?.value,
        invoicetypecd: "DebitNote",
        invoiceid: params?.id && !isNaN(params?.id) ? params.id : 0,
      })
    );

    const openingBalanceDate =
      res?.data?.getMinMaxInvoiceDate?.openingbalancedate ?? null;

    setFirstInvoiceDate(openingBalanceDate);
  const invoiceDate =savedPostingDate? moment(savedPostingDate * 1000).format('YYYY-MM-DD') : openingBalanceDate;
    

    setData((prev) => ({ ...prev, invoiceDate }));
    setInitialState((prev) => ({ ...prev, invoiceDate }));
  } catch (error) {
    setBackdropOpen(false);
    console.log("error", error);
  }
}

  const [createPdf, progress] = useCreatePdfMutation();
  let url = path + `Invoices/DebitNote/Ledgerx_DebitNote_Invoice_${data.voucherNumber}.pdf`;
  let uri = `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${url}`;
  const generatePdf = async (id) => {
    return await createPdf({
      path: url,
      type: 'drnoteMaster',
      invoiceids: id,
    });
  };


  async function saveChanges(obj) {
    const {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      paymentType,
      receivedAmount,
      receivedAccount,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    } = data;

    const formData = {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      paymentType,
      receivedAmount,
      receivedAccount,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    };

    if (formVaidation(formData)) {
      const updatedTableItemRow = [...items];
      let isvalid = true;
      let requireds = [];
      let invalids = [];
      let invalidDiscount = [];
      let errorArr = [];
      let itemValid = true;
      let nonItemValid = true;

      updatedTableItemRow.map((ele, ind) => {
        if (ele?.itemCode?.value !== '') {
          if (ele?.itemCode?.value === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('itemCode' + ind);
            requireds.push('Item Code');
          }
          if (ele?.name?.value === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('itemName' + ind);
            requireds.push('Item Name');
          }

          if (registrationType != 1) {
            // if (data?.taxability?.value === "") {
            //   isvalid = false;
            //   itemValid = false
            //   requireds.push("Taxability");
            //   errorArr.push("taxability" + ind);
            // }
            if (
              data?.taxability?.value == 1 ||
              data?.taxability?.value == 4 ||
              data?.taxability?.value == 6 ||
              data?.taxability?.value == 8 ||
              data?.taxability?.value == 9 ||
              data?.taxability?.value == 7 ||
              data?.taxability?.value === ''
            ) {
              if (ele?.GSTRate === '') {
                isvalid = false;
                itemValid = false;
                requireds.push('GST Rate');
                errorArr.push('GSTRate' + ind);
              }
            }
          
          if (
            (ele?.HSN?.value === '' || ele?.HSN?.value === undefined || ele?.HSN?.value === null) &&
            // EInvoiceFlag &&
            // partyType === 'CUSTOMER'
            companyType === 2
            // &&
            // data.partyCategory !== "UB"
          ) {
            isvalid = false;
            itemValid = false;
            errorArr.push('hsnCode' + ind);
            requireds.push('HSN/SAC Code');
          }
        }
          if (ele?.qty == 0 || ele?.qty === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('qty' + ind);
            requireds.push('Quantity');
          }
          if (ele?.qty !== '' && !new RegExp(/^(?=.+)(?:[1-9]\d*|0\d*)?(?:\.\d+)?$/).test(ele?.qty)) {
            isvalid = false;
            itemValid = false;
            invalids.push(' Quantity');
          }
          if (ele?.qty !== 0 && (ele?.rate == '' || ele?.rate == 0)) {
            isvalid = false;
            itemValid = false;
            requireds.push('Rate');
            errorArr.push('rate' + ind);
          }

          if (ele?.dicount !== '' && Number(ele?.dicount) > Number(ele?.amount)) {
            isvalid = false;
            itemValid = false;
            errorArr.push('dicount' + ind);
            invalidDiscount.push(' Discount');
          }
        }

        return isvalid;
      });
      const updatedTableNonItemRow = [...nonItems];
      updatedTableNonItemRow.map((ele, ind) => {
        if (ele?.ledgerAccount?.value !== '') {
          if (ele?.ledgerAccount?.value === '') {
            isvalid = false;
            nonItemValid = false;
            errorArr.push('ledgerAccount' + ind);
            requireds.push('Ledger Account');
          }
          if (registrationType != 1) {
            // if (data?.taxability?.value === "") {
            //   isvalid = false;
            //   nonItemValid = false
            //   requireds.push("Taxability");
            //   errorArr.push("nonTaxability" + ind);
            // }
            if (
              data?.taxability?.value == 1 ||
              data?.taxability?.value == 4 ||
              data?.taxability?.value == 6 ||
              data?.taxability?.value == 8 ||
              data?.taxability?.value == 9 ||
              data?.taxability?.value == 7 ||
              data?.taxability?.value === ''
            ) {
              if (ele?.GSTRate === '') {
                isvalid = false;
                nonItemValid = false;
                errorArr.push('nonGSTRate' + ind);
                requireds.push('GST Rate');
              }
            }
          
          if (
            (ele?.HSN?.value === '' || ele?.HSN?.value === undefined || ele?.HSN?.value === null) &&
            // EInvoiceFlag &&
            companyType === 2 && partyType==="CUSTOMER"
            // partyType === 'CUSTOMER'
            // &&
            // data.partyCategory !== "UB"
          ) {
            isvalid = false;
            nonItemValid = false;
            errorArr.push('nonhsnCode' + ind);
            requireds.push('HSN/SAC Code');
          }
        }
          if (ele?.taxableAMount === '' || Number(ele?.taxableAMount) === 0 || ele?.taxableAMount === '0') {
            isvalid = false;
            nonItemValid = false;
            if (registrationType != 1) {
              requireds.push('Taxable Amount');
              errorArr.push('nontaxableAMount' + ind);
            } else {
              requireds.push('Net Amount');
              errorArr.push('nontaxableAMount' + ind);
            }
          }
        }

        return isvalid;
      });
      if (isvalid) {
        if (totNetAmt === 0) {
          if (updatedTableItemRow.length === 0 && updatedTableNonItemRow.length === 0) {
            setItems([newItemObj]);
            setNonItems([newNonItemObj]);
          }
          isvalid = false;
          setBackdropOpen(false);
          showWarningSnackbar('Please complete the actions in your entry table');
        }
      }
      if (isvalid && partyType === 'CUSTOMER') {
        isvalid = checkPriceTypeWithInvDate(data?.invoiceDate);
      }
      if (isvalid) {
        try {
          setBackdropOpen(true);
          let randomNumber = Math.floor(Math.random() * 100 + 1);
          const comments = data.remarks;

          let crDrDetailsArr = [];
          let crDrAddrArr = [];
          let crDrLineItemArr = [];
          let crDrNonLineItemArr = [];
          let crDrTcsArr = [];
          let crDrTdsArr = [];
          let crDrMasterArr = [];
          let crDrTransArr = [];
          let dispatchArr = [];
          let invoNos = [];
          // data.originalInvoiceNumber.map((ele) => {
          //   invoNos.push(ele.value);
          // });

          const debitMasterData = {
            crdrnotetypecd: String('DebitNote'),
            crdrnotedate: Number(Math.floor(new Date(invoiceDate).getTime() / 1000)),
            crdrnotenumber: String(voucherNumber),
            invoicetypecd: String(''),
            gsttypecd: String(taxability?.value),
            partyid: Number(partyName.value),
            deliveryaddressid: Number(0),
            paymenttype: String(paymentType),
            grandtotalamount: Number(netAmountToPay),
            creditduration: Number(data.creditPeriod === '' ? 0 : data.creditPeriod),
            psflag: Number(0),
            reversechargeflag: Number(data.reverseChargeFlag),
            balancedueamount: Number(data.balanceDueAmt),
            consigneename: String(data.consigneeName !== '' ? data.consigneeName : ''),
            consigneegstin: String(data.consigneeGST !== '' ? data.consigneeGST : '') || '',
            companystate: String(companyState),
            placeofsupply: String(placeOfSupply.value),
            cancelflag: Number(0),
            cancelremark: String(''),
            roundoffamount: Number(data.roundOff),
            discounttype: Number(data.adjustmentsType),
            discountvalue: Number(data.adjustmentsValue),
            adjustmentamount: Number(adjustments),
            // serialnumber: String(data.seriesVouchers.value),
             serialnumber: Number(voucherFlag===-1)?"":String(data.seriesVouchers.value),
            currencycode: String(data.currency.value),
            currencyrate: Number(data.currencyRate),
            originalinvoicenumber: String(data?.originalInvoiceNumber?.value),
            crdrnotepdf: String(uri),
            partyregistrationtype: String(data.partyCategory),
            // partydisplayname: String(data?.partyName?.label),
          };

          crDrMasterArr.push(debitMasterData);
          const debitDetailsData = {
            totaltaxableamount: Number(totTaxAmt),
            totalgst: Number(totGST),
            totalgstcess: Number(totGSTCess),
            totaladjustments: Number(data.adjustments === '' ? 0 : data.adjustments),
            comments: String(comments || ''),
            accountid: Number(receivedAccount.value === '' ? 0 : receivedAccount.value),
            partamount: Number(receivedAmount === '' ? 0 : receivedAmount),
            transportationcd: String(data.transpotationMode),
            vehiclenumber: String(data.vehicleNumber),
            dispatchdate: data.dateOfDispatch ? Number(Math.floor(new Date(data.dateOfDispatch).getTime() / 1000)) : 0,
            ewaybillnumber: data.eWayBill ? String(data.eWayBill) : '',
          };

          crDrDetailsArr.push(debitDetailsData);

          if (items.length > 0) {
            items?.map((ele, index) => {
              if (ele?.itemCode?.value !== '') {
                const lineItemsData = {
                  crdrnoteitemid: Number(index + 1),
                  lineitemnumber: Number(index + 1),
                  lineitemtype: String('LINE'),
                  itemid: Number(ele.name.value === '' ? 0 : ele.name.value),
                  quantity: Number(ele.qty),
                  unittypecd: String(ele.units),
                  itemrate: Number(ele.rate),
                  itemamount: Number(ele.amount),
                  itemdiscount: Number(ele.dicount),
                  gstrate: Number(ele.GSTRate === '' ? 0 : ele.GSTRate),
                  gsttypecd: String('0'),
                  gstamount: Number(ele?.IGST),
                  gstcess: Number(ele.GSTCess),
                  hsnsaccode: String(ele.HSN.value === '' ? 0 : ele.HSN.value),
                  netamount: Number(ele.netAmount),
                  taxability: String(data?.taxability.value),
                  reason: String(ele?.reason),
                  pricetype: String(ele?.priceType?.label),
                  manualdiscount: Number(ele?.manualDiscount === true ? 1 : 0),
                  manualcess: Number(ele?.manualCess === true ? 1 : 0),
                  pricetypeid: Number(ele?.priceType?.value),
                  itemtype: String(ele.itemType),
                  manualgst:Number(ele?.manualGSTFlag)
                };

                crDrLineItemArr.push(lineItemsData);
              }
            });
          }

          if (nonItems.length > 0) {
            nonItems.map((ele, index) => {
              if (ele?.ledgerAccount?.value !== '') {
                const nonItemsData = {
                  crdrnoteitemid: Number(index + 1),
                  lineitemtype: String('NONELINE'),
                  ledgeraccountid: Number(ele.ledgerAccount.value),
                  hsnsaccode: String(ele.HSN.value === '' ? 0 : ele.HSN.value),
                  itemdescription: String(ele.description),
                  taxableamount: Number(ele.taxableAMount),
                  gstrate: Number(ele.GSTRate),
                  gsttypecd: String('0'),
                  gstamount: Number(ele.IGST),
                  gstcess: Number(ele.GSTCess),
                  netamount: Number(ele.netAmount),
                  taxability: String(data?.taxability.value),
                  reason: String(ele?.reason),
                  manualgst:Number(ele?.manualGSTFlag)
                };

                crDrNonLineItemArr.push(nonItemsData);
              }
            });
          }
          const tdsData = {
            tdsapplicablecd: String(0),
            totaltaxableamount: Number(totTaxAmt),
            ineligibletcflag: Number(data.ineligibleITCFlag === '' ? 0 : data.ineligibleITCFlag),
            reversechargeflag: Number(data.reverseChargeFlag === '' ? 0 : data.reverseChargeFlag),
            gstcesstotal: Number(totGSTCess),
            tdsamount: Number(data.tdsAmount),
            adjustmentamount: Number(data.adjustments),
            tdssection: String(data.tdsOptions),
            tdspercentage: Number(data.tdsPercent),
            tdsmanual: Number(data.manualTdsFlag),
          };

          crDrTdsArr.push(tdsData);
          const tcsData = {
            tcsapplicablecd: String(data.tcsFlag === '' ? 0 : data.tcsFlag),
            totaltaxableamount: Number(totTaxAmt),
            ineligibletcflag: Number(data.ineligibleITCFlag === '' ? 0 : data.ineligibleITCFlag),
            reversechargeflag: Number(data.reverseChargeFlag === '' ? 0 : data.reverseChargeFlag),
            gstcesstotal: Number(totGSTCess),
            tcsamount: Number(data.tcsAmount),
            adjustmentamount: Number(data.adjustments),
            tcssection: String(data.tcsOptions),
            tcspercentage: Number(data.tcsPercent),
            tcsmanual: Number(data.manualTcsFlag),
          };

          crDrTcsArr.push(tcsData);
          invTransArr.map((ele, ind) => {
            let obj = {
              accountid: Number(ele.accID),
              creditamount: Number(Number(ele.creditAmt).toFixed(2)),
              debitamount: Number(Number(ele.debitAmt).toFixed(2)),
              comments: String(data.remarks),
              // entryordernumber: Number(ind + 1),
              transactiontypecd: String(Number(ele.debitAmt) !== 0 ? 'Debit' : 'Credit'),
            };

            crDrTransArr.push(obj);
          });
          const dispatchData = {
            dispatchid: Number(randomNumber),
            transportationcd: String(data.transportMode),
            vehiclenumber: String(data.vehicleNumber),
            dispatchdate: data.dateOfDispatch ? Number(Math.floor(new Date(data.dateOfDispatch).getTime() / 1000)) : 0,
            ewaybillnumber: data.ewayBillNo ? String(data.ewayBillNo) : '',
          };

          dispatchArr.push(dispatchData);
          if (isAdrressEmpty) {
            let add =
              deliveryAddressDetails.deliveryAddress !== ''
                ? deliveryAddressDetails.deliveryAddress
                : "";
            const addressDetails = {
              consigneename: data.consigneeName !== '' ? String(data.consigneeName) : String(''),
              consigneegstin: data.consigneeGST !== '' ? String(data.consigneeGST) : String(''),
              objecttype: String('DebitDelivery'),
              line1: String(add),
              line2: String(''),
              line3: String(''),
              city: String(
                deliveryAddressDetails.city?.value ?? 
            '',
              ),
              statecode: Number(
                deliveryAddressDetails?.states?? 0
              ),
              pincode: String(
                deliveryAddressDetails.pincode ?? ''
              ),
              countrycode: String(
                deliveryAddressDetails.country  ?? ''
              ),
              district: String(
                deliveryAddressDetails.district ??''
              ),
              foreignstate:String(deliveryAddressDetails?.stateCD?.label??''),
              foreigndistrict:String(deliveryAddressDetails.districtCD?.label ?? '')
              // objectid: Number(invoiceEntry?.crdrnoteid),
              // expiredtimestamp: Number(0),
            };

            crDrAddrArr.push(addressDetails);
          }
          let billAdd =
            billingAddressDetails.billingAddress !== ''
              ? billingAddressDetails.billingAddress
              : "";
          const billaddressDetails = {
            consigneename: data?.partyName?.label !== '' ? String(data?.partyName?.label) : String(''),
            consigneegstin: data.gstin !== '' ? String(data?.gstin) : String(''),
            objecttype: String('DebitBilling'),
            line1: String(billAdd),
            line2: String(''),
            line3: String(''),
            city: String(
              billingAddressDetails.city.value ??
              '',
            ),
            statecode: Number(
              billingAddressDetails.states  ?? 0
            ),
            pincode: String(
              billingAddressDetails.pincode??''
            ),
            countrycode: String(
              billingAddressDetails.country ?? ''
            ),
            district: String(
              billingAddressDetails.district  ?? ''
            ),
            foreignstate:String(billingAddressDetails?.stateCD?.label??''),
              foreigndistrict:String(billingAddressDetails.districtCD?.label ?? '')
            // objectid: Number(invoiceEntry?.crdrnoteid),
            // expiredtimestamp: Number(0),
          };

          crDrAddrArr.push(billaddressDetails);
          // const attachedArr = itemsRows.map((ele) => ({
          //   documentname: ele.documentname,
          //   attachmentname: ele.imagename,
          //   attachmenturl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.imagename}`,
          //   type: ele?.type?.split("/")[1],
          // }));
          const attachedArr = itemsRows.map((ele) => ({
            attachmentname: String(ele.imagename),
            attachmenturl: String(`${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.imagename}`),
            documentname: String(ele.documentname),
            type: String(ele?.type?.split('/')[1] ?? ''),
          }));

          const resCrDrInvoice = await API.graphql(
            graphqlOperation(createCrDrNoteTransactionsArray, {
              createCrDrNoteTransactionsArrayInput: {
                crdrnotedetails: crDrDetailsArr,
                crdrnoteinvoices: [],
                crdrnotelineitems: crDrLineItemArr,
                crdrnotelinenonitems: crDrNonLineItemArr,
                crdrnotetcsdetails: crDrTcsArr,
                crdrnotetdsdetails: crDrTdsArr,
                crdrnotetransactionmaster: crDrMasterArr,
                transactiondetails: crDrTransArr,
                crdrnotedispatch: dispatchArr,
                crdrattachment: attachedArr,
                partyaddressentity: crDrAddrArr,
              },
            })
          );

          if (resCrDrInvoice.data.createCrDrNoteTransactionsArray.statuscode == 'Sucess') {
            let responses = itemsRows.map((element) => {
              if (element.file) {
                return uploadToServer(
                  element.file,
                  element.imagename.replace('${id}', resCrDrInvoice.data.createCrDrNoteTransactionsArray.crdrnoteid),
                  element.type
                );
              }
            });
            await savePaymentDetails(resCrDrInvoice.data.createCrDrNoteTransactionsArray.crdrnoteid);
            dispatch(dashboardApi.util.invalidateTags(['dashboard', 'Dashboard_closingStock']));
            dispatch(setNavigationBlocked(false));
            showSuccessSnackbar('Debit Note generated successfully');
            generatePdf(resCrDrInvoice.data.createCrDrNoteTransactionsArray.crdrnoteid);

            if (obj.new == false) {
              setBackdropOpen(false);
              setSendEmailData({
                email: '',
                name: '',
                recipientId: Number(crDrMasterArr?.[0]?.partyid),
                id: Number(resCrDrInvoice.data?.createCrDrNoteTransactionsArray?.crdrnoteid),
                invoiceNumber: crDrMasterArr?.[0]?.crdrnotenumber,
              })
              setShareOpen(url);
            } else {
              // window.location.reload();
              setBackdropOpen(false);
              setData((prev) => ({
                ...resetData,
                invoiceDate: prev?.invoiceDate,
                customerOrderDate: prev?.customerOrderDate,
              }));
              getLatestCrDrNote();
              // getVoucherDetails("Receipt");
              dispatch(VoucherSettingsApi.util.invalidateTags([{ type: 'listVoucherSettings', id: 'DebitInvoice' }]));
              dispatch(VoucherSettingsApi.util.invalidateTags(['listUsedVoucherSettings']));
              setItemValid(true);
              setNonItemValid(true);
              setNonItems([resetNonItems]);
              setItems([resetItems]);
              setItemsRows([]);
            }
          } else {
            setBackdropOpen(false);

            showErrorSnackbar(resCrDrInvoice.data.createCrDrNoteTransactionsArray.statusmessage);
          }
        } catch (error) {
          setBackdropOpen(false);
          const rawMessage = error?.errors[0]?.message?.split('RDSHttp:')[1];
          const parsedMessage = JSON.parse(rawMessage).message;
          const errorMessage = parsedMessage.split('ERROR: ')[1].split(';')[0];
          showWarningSnackbar(errorMessage);
          console.log('error', error);
        }
      } else {
        setBackdropOpen(false);
        setTableErrArr(errorArr);
        requireds = [...new Set(requireds)];
        if (requireds.length === 1) {
          showWarningSnackbar(`${requireds}` + ' ' + 'is required');
        }
        if (requireds.length > 1) {
          showWarningSnackbar(`${requireds}` + ' ' + 'are required');
        }
        setItemValid(itemValid);
        setNonItemValid(nonItemValid);
      }
    } else {
      setErrorArr({ ...data.errorStatus });
    }
  }

  async function savePaymentDetails(invID) {
    try {
      let tranSDetailsArr = [];
      let masterArr = [];
      let linkedArr = [];
      const comments = data.remarks.split('\n');
      if (data.paymentType !== 'Credit') {
        const masterData = {
          bankreferencenumber: data.bankReferenceNo,
          comments: comments?.join('**'),
          entrydate: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
          transactiontypecd: data.paymentType == 'Cash' ? 'CashReceipt' : data.paymentType == 'Bank' ? 'BankReceipt' : 'Credit',
          vouchercode: transGeneralSettingsFlag === -1 ? data.transactionVoucher : '',
          serialnumber: data.transactionSeries.value,
          cancelflag: 0,
        };
        masterArr.push(masterData);

        paymentTransArr.map((ele, index) => {
          const paymentTransDetails = {
            accountid: ele.accID,
            comments: comments?.join('**'),
            creditamount: Number(ele.creditAmt).toFixed(2),
            debitamount: Number(ele.debitAmt).toFixed(2),
            entryordernumber: index + 1,

            transactiontypecd: ele.debitAmt !== 0 ? 'Debit' : 'Credit',
            cancelflag: 0,
          };
          tranSDetailsArr.push(paymentTransDetails);
        });
        const linkCurrentPayment = {
          linkedamount: data.receivedAmount,
          transactiontypecd: 'DebitNote',
          isdirect: 1,
          objectattribute: data.voucherNumber,
          objectid: invID,
          objecttype: data.paymentType,
          accountid: partyAccountID,
          paymentvouchernumber: data?.transactionVoucher,
        };
        linkedArr.push(linkCurrentPayment);
        const result = await API.graphql(
          graphqlOperation(createTransactionWithSpecificTime, {
            transactionmaster: JSON.stringify(masterArr),
            transactiondetails: JSON.stringify(tranSDetailsArr),
            transactionattachment: JSON.stringify([]),
            transactiontdsdetails: JSON.stringify([]),
            transactionrelation: JSON.stringify(linkedArr),
            mode: 1,
            transactiontcsdetails: JSON.stringify([]),
          })
        );
        let url = path + `Invoices/Receipt/Ledgerx_Receipt_${data.transactionVoucher}.pdf`;
        await createPdf({
          path: url,
          type: 'receipt',
          transactionid: result.data?.createTransactionWithSpecificTime?.transactionid,
        });
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }

  async function saveEditChanges() {
    const {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      paymentType,
      receivedAmount,
      receivedAccount,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    } = data;

    const formData = {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      paymentType,
      receivedAmount,
      receivedAccount,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    };
    let invoNos = [];
    // data.originalInvoiceNumber.map((ele) => {
    //   invoNos.push(ele.value);
    // });

    if (formVaidation(formData)) {
      const updatedTableItemRow = [...items];
      let isvalid = true;
      let requireds = [];
      let invalids = [];
      let invalidDiscount = [];
      let errorArr = [];
      let itemValid = true;
      let nonItemValid = true;

      updatedTableItemRow.map((ele, ind) => {
        if (ele?.itemCode?.value !== '') {
          if (ele?.itemCode?.value === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('itemCode' + ind);
            requireds.push('Item Code');
          }
          if (ele?.name?.value === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('itemName' + ind);
            requireds.push('Item Name');
          }

          if (registrationType != 1) {
            // if (data?.taxability?.value === "") {
            //   isvalid = false;
            //   itemValid = false
            //   requireds.push("Taxability");
            //   errorArr.push("taxability" + ind);
            // }
            if (
              data?.taxability?.value == 1 ||
              data?.taxability?.value == 4 ||
              data?.taxability?.value == 6 ||
              data?.taxability?.value == 8 ||
              data?.taxability?.value == 9 ||
              data?.taxability?.value == 7 ||
              data?.taxability?.value === ''
            ) {
              if (ele?.GSTRate === '') {
                isvalid = false;
                itemValid = false;
                requireds.push('GST Rate');
                errorArr.push('GSTRate' + ind);
              }
            }
          
          if (
            (ele?.HSN?.value === '' || ele?.HSN?.value === undefined || ele?.HSN?.value === null) &&
            // EInvoiceFlag &&
            // partyType === 'CUSTOMER'
            companyType === 2
            // &&
            // data.partyCategory !== "UB"
          ) {
            isvalid = false;
            itemValid = false;
            errorArr.push('hsnCode' + ind);
            requireds.push('HSN/SAC Code');
          }
        }
          if (ele?.qty == 0 || ele?.qty === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('qty' + ind);
            requireds.push('Quantity');
          }
          if (ele?.qty !== '' && !new RegExp(/^(?=.+)(?:[1-9]\d*|0\d*)?(?:\.\d+)?$/).test(ele?.qty)) {
            isvalid = false;
            itemValid = false;
            invalids.push(' Quantity');
          }
          if (ele?.qty !== 0 && (ele?.rate == '' || ele?.rate == 0)) {
            isvalid = false;
            itemValid = false;
            requireds.push('Rate');
            errorArr.push('rate' + ind);
          }

          if (ele?.dicount !== '' && Number(ele?.dicount) > Number(ele?.amount)) {
            isvalid = false;
            itemValid = false;
            errorArr.push('dicount' + ind);
            invalidDiscount.push(' Discount');
          }
        }

        return isvalid;
      });
      const updatedTableNonItemRow = [...nonItems];
      updatedTableNonItemRow.map((ele, ind) => {
        if (ele?.ledgerAccount?.value !== '') {
          if (ele?.ledgerAccount?.value === '') {
            isvalid = false;
            nonItemValid = false;
            errorArr.push('ledgerAccount' + ind);
            requireds.push('Ledger Account');
          }
          if (registrationType != 1) {
            if (
              data?.taxability?.value == 1 ||
              data?.taxability?.value == 4 ||
              data?.taxability?.value == 6 ||
              data?.taxability?.value == 8 ||
              data?.taxability?.value == 9 ||
              data?.taxability?.value == 7 ||
              data?.taxability?.value === ''
            ) {
              if (ele?.GSTRate === '') {
                isvalid = false;
                nonItemValid = false;
                errorArr.push('nonGSTRate' + ind);
                requireds.push('GST Rate');
              }
            }
          
          if (
            (ele?.HSN?.value === '' || ele?.HSN?.value === undefined || ele?.HSN?.value === null) &&
            // EInvoiceFlag &&
            companyType === 2 && partyType==="CUSTOMER"
            // partyType === 'CUSTOMER'
            // &&
            // data.partyCategory !== "UB"
          ) {
            isvalid = false;
            nonItemValid = false;
            errorArr.push('nonhsnCode' + ind);
            requireds.push('HSN/SAC Code');
          }
        }
          if (ele?.taxableAMount === '' || Number(ele?.taxableAMount) === 0 || ele?.taxableAMount === '0') {
            isvalid = false;
            nonItemValid = false;
            if (registrationType != 1) {
              requireds.push('Taxable Amount');
              errorArr.push('nontaxableAMount' + ind);
            } else {
              requireds.push('Net Amount');
              errorArr.push('nontaxableAMount' + ind);
            }
          }
        }

        return isvalid;
      });
      if (isvalid) {
        if (totNetAmt === 0) {
          if (updatedTableItemRow.length === 0 && updatedTableNonItemRow.length === 0) {
            setItems([newItemObj]);
            setNonItems([newNonItemObj]);
          }
          isvalid = false;
          setBackdropOpen(false);
          showWarningSnackbar('Please complete the actions in your entry table');
        }
      }
      if (isvalid && partyType === 'CUSTOMER') {
        isvalid = checkPriceTypeWithInvDate(data?.invoiceDate);
      }
      if (isvalid) {
        const comments = data.remarks;
        const CrDrMasterData = {
          crdrnotepdf: invoiceEntry?.crdrnotepdf,
          crdrnotedate: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
          crdrnoteid: invoiceEntry.crdrnoteid,
          crdrnotetypecd: 'DebitNote',
          deliveryaddressid: 0,
          gsttypecd: String(taxability?.value),
          grandtotalamount: Number(netAmountToPay),
          invoicetypecd: '',
          creditduration: data.creditPeriod === '' ? 0 : data.creditPeriod,
          partyid: partyName.value,
          paymenttype: paymentType,
          transactionid: invoiceEntry?.transactionid,
          psflag: 0,
          reversechargeflag: data.reverseChargeFlag,
          balancedueamount: Number(data.balanceDueAmt),
          crdrnotenumber: voucherNumber===""?String(data.seriesVouchers.label):String(voucherNumber),
          // serialnumber: data.seriesVouchers.value,
           serialnumber: Number(voucherFlag===-1)?"":String(data.seriesVouchers.value),
          consigneename: data.consigneeName !== '' ? data.consigneeName : '',
          consigneegstin: (data.consigneeGST !== '' ? data.consigneeGST : '') || '',
          placeofsupply: String(placeOfSupply.value),
          cancelflag: 0,
          companystate: companyState,
          discounttype: data.adjustmentsType,
          adjustmentamount: Number(data.adjustments),
          discountvalue: Number(data.adjustmentsValue),
          roundoffamount: Number(data.roundOff),
          currencycode: data.currency.value,
          currencyrate: data.currencyRate,
          originalinvoicenumber: data?.originalInvoiceNumber?.value,
          companybranchid: 0,
          expiredtimestamp: 0,
          cancelremark: '',
          partyregistrationtype: data.partyCategory,
          partydisplayname: data?.partyName?.label,
        };
        updateCrDrData(CrDrMasterData);
      } else {
        setBackdropOpen(false);
        setTableErrArr(errorArr);
        requireds = [...new Set(requireds)];
        if (requireds.length === 1) {
          showWarningSnackbar(`${requireds}` + ' ' + 'is required');
        }
        if (requireds.length > 1) {
          showWarningSnackbar(`${requireds}` + ' ' + 'are required');
        }
        setItemValid(itemValid);
        setNonItemValid(nonItemValid);
      }
    }
  }

  async function updateCrDrData(masterData) {
    try {
      let invTransactionArray = [];
      let addressArr = [];
      setBackdropOpen(true);
      const comments = data.remarks;
      const CrDrDetailsData = {
        accountid: data.receivedAccount.value === undefined || data.receivedAccount.value === '' ? 0 : data.receivedAccount.value,
        comments: comments,
        crdrnoteid: invoiceEntry?.crdrnoteid,
        dispatchdate: data.dateOfDispatch? Math.floor(new Date(data.dateOfDispatch).getTime() / 1000):0,
        ewaybillnumber: data.ewayBillNo,
        partamount: data.receivedAmount === '' ? 0 : data.receivedAmount,
        totaladjustments: data.adjustments === '' ? 0 : data.adjustments,
        totalgst: totGST,
        totalgstcess: totGSTCess,
        totaltaxableamount: totTaxAmt,
        transportationcd: data.transportMode,
        vehiclenumber: data.vehicleNumber,
        companybranchid: 0,
        expiredtimestamp: 0,
      };
      let itemArr = [];
      let nonItemArr = [];
      if ([...items, ...deletedItems].length > 0) {
        [...items, ...deletedItems]?.map(async (ele, index) => {
          if (ele?.itemCode?.value !== '') {
            const lineItemsData = {
              crdrnoteitemid: ele?.crdrnoteitemid ? ele?.crdrnoteitemid : index + 1,
              gstamount: Number(ele?.IGST),
              gstrate: Number(ele.GSTRate) == '' ? 0 : Number(ele.GSTRate),
              gsttypecd: '',
              gstcess: ele.GSTCess,
              reason: ele.reason !== null && ele?.reason !== undefined && ele?.reason !== '' ? ele?.reason : '',
              taxability: data?.taxability.value,
              hsnsaccode: String(ele.HSN.value == '' ? 0 : ele?.HSN?.value),
              itemamount: ele.amount,
              itemdiscount: Number(ele.dicount),
              itemid: ele?.name?.value == '' ? 0 : ele?.name?.value,
              itemname: ele?.name?.label,
              itemrate: Number(ele.rate),
              lineitemnumber: index + 1,
              lineitemtype: 'LINE',
              netamount: ele.netAmount,
              quantity: Number(ele.qty),
              pricetype: ele?.priceType?.label,
              pricetypeid: ele.priceType?.value,
              unittypecd: ele.units,
              crdrnoteid: invoiceEntry?.crdrnoteid,

              companybranchid: 0,
              expiredtimestamp: ele.expiredtimestamp ? ele?.expiredtimestamp : 0,
              lotid: '',
              manualdiscount: ele?.manualDiscount === true ? 1 : 0,
              manualcess: ele?.manualCess === true ? 1 : 0,
              itemtype: String(ele.itemType),
              crdrnotedate: Math.floor(new Date(data?.invoiceDate).getTime() / 1000),
              manualgst:Number(ele?.manualGSTFlag)
            };
            itemArr.push(lineItemsData);
          }
        });
      }
      if ([...nonItems, ...deletedNonItems].length > 0) {
        [...nonItems, ...deletedNonItems].map(async (ele, index) => {
          if (ele?.ledgerAccount?.value !== '') {
            const nonItemsData = {
              crdrnoteitemid: ele?.crdrnoteitemid ? ele?.crdrnoteitemid : index + 1,
              hsnsaccode: String(ele?.HSN?.value == '' ? 0 : ele?.HSN?.value),
              gstamount: Number(ele?.IGST),
              gstrate: Number(ele.GSTRate) == '' ? 0 : Number(ele.GSTRate),
              reason: ele.reason !== null && ele?.reason !== undefined && ele?.reason !== '' ? ele?.reason : '',
              taxability: '',
              gsttypecd: '',
              itemdescription: ele.description,
              ledgeraccountid: ele?.ledgerAccount?.value == '' ? 0 : ele?.ledgerAccount?.value,
              lineitemtype: 'NONELINE',
              netamount: ele.netAmount,
              taxableamount: ele.taxableAMount,
              gstcess: ele.GSTCess,
              crdrnoteid: invoiceEntry?.crdrnoteid,
              companybranchid: 0,
              expiredtimestamp: ele.expiredtimestamp ? ele?.expiredtimestamp : 0,
              manualgst:Number(ele?.manualGSTFlag)
            };
            nonItemArr.push(nonItemsData);
          }
        });
      }
      const tdsData = {
        adjustmentamount: Number(data.adjustments),
        enteredtimestamp: invoiceEntry.RelatedCrDrNoteTCSDetails?.[0]?.enteredtimestamp,
        gstcesstotal: Number(totGSTCess),
        ineligibletcflag: data.ineligibleITCFlag === '' ? 0 : data.ineligibleITCFlag,
        crdrnoteid: invoiceEntry?.crdrnoteid,
        reversechargeflag: data.reverseChargeFlag === '' ? 0 : data.reverseChargeFlag,
        tdsamount: Number(data.tdsAmount),
        tdsapplicablecd: 0,
        tdssection: data.tdsOptions,
        totaltaxableamount: Number(totTaxAmt),
        tdspercentage: Number(data.tdsPercent),
        tdsmanual: data.manualTdsFlag,
        companybranchid: 0,
        expiredtimestamp: 0,
      };
      const tcsData = {
        adjustmentamount: Number(data.adjustments),
        enteredtimestamp: invoiceEntry?.RelatedCrDrNoteTCSDetails?.[0]?.enteredtimestamp,
        gstcesstotal: Number(totGSTCess),
        ineligibletcflag: data.ineligibleITCFlag === '' ? 0 : data.ineligibleITCFlag,
        crdrnoteid: invoiceEntry?.crdrnoteid,
        reversechargeflag: data.reverseChargeFlag === '' ? 0 : data.reverseChargeFlag,
        tcsamount: Number(data.tcsAmount),
        tcsapplicablecd: data.tcsFlag === '' ? 0 : data.tcsFlag,
        tcssection: data.tcsOptions,
        totaltaxableamount: Number(totTaxAmt),
        tcspercentage: Number(data.tcsPercent),
        tcsmanual: data.manualTcsFlag,
        companybranchid: 0,
        expiredtimestamp: 0,
      };
      const dispatchData = {
        dispatchdate: data.dateOfDispatch? Math.floor(new Date(data.dateOfDispatch).getTime() / 1000):0,

        dispatchid: invoiceEntry?.relatedcrdrnotedispatch[0].dispatchid,
        ewaybillnumber: data.ewayBillNo,
        crdrnoteid: invoiceEntry?.crdrnoteid,
        transportationcd: data.transportMode,
        vehiclenumber: data.vehicleNumber,
        companybranchid: 0,
        expiredtimestamp: 0,
      };
      if (isAdrressEmpty) {
        let add =
          deliveryAddressDetails?.deliveryAddress !== ''
            ? deliveryAddressDetails?.deliveryAddress
            : "";
        const addressDetails = {
          consigneename: data.consigneeName !== '' ? String(data.consigneeName) : String(''),
          consigneegstin: data.consigneeGST !== '' ? String(data.consigneeGST) : String(''),
          city:
           deliveryAddressDetails.city?.value ?? '',

          countrycode:
            deliveryAddressDetails.country  ?? '',

          line1: add,
          line2: '',
          line3: '',
          objectid: invoiceEntry?.crdrnoteid,
          objecttype: 'DebitDelivery',

          pincode:
            deliveryAddressDetails.pincode??'',

          statecode:
            deliveryAddressDetails?.states ?? 0,

          district:
            deliveryAddressDetails.district??'',

          expiredtimestamp: 0,
          financialyearid: userPreferece?.financialYear?.financialyearid,
          foreignstate:String(deliveryAddressDetails?.stateCD?.label??''),
              foreigndistrict:String(deliveryAddressDetails.districtCD?.label ?? '')
        };
        addressArr.push(addressDetails);
      }

      let billAdd =
        billingAddressDetails?.billingAddress !== '' ? billingAddressDetails?.billingAddress :"";
      const billaddressDetails = {
        consigneename: data?.partyName?.label !== '' ? String(data?.partyName?.label) : String(''),
        consigneegstin: data.gstin !== '' ? String(data?.gstin) : String(''),
        city:
          billingAddressDetails.city.value ?? '',

        countrycode:
          billingAddressDetails.country 
            ?? '',

        line1: billAdd,
        line2: '',
        line3: '',
        objectid: invoiceEntry?.crdrnoteid,
        objecttype: 'DebitBilling',

        pincode:
          billingAddressDetails.pincode??'',

        statecode:
          billingAddressDetails.states ?? 0,

        district:
          billingAddressDetails.district ?? '',

        expiredtimestamp: 0,
        financialyearid: userPreferece?.financialYear?.financialyearid,
        foreignstate:String(billingAddressDetails?.stateCD?.label??''),
              foreigndistrict:String(billingAddressDetails.districtCD?.label ?? '')
      };
      addressArr.push(billaddressDetails);

      invTransArr.map((ele, ind) => {
        let obj = {
          accountid: Number(ele.accID),
          comments: data.remarks,
          debitamount: Number(ele.debitAmt).toFixed(2),
          creditamount: Number(ele.creditAmt).toFixed(2),
          // entryordernumber: ind + 1,
          transactionid: Number(invoiceEntry?.transactionid),
          transactiontypecd: ele.debitAmt !== 0 ? 'Debit' : 'Credit',
          enteredtimestamp: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
          cancelflag: 0,
        };
        invTransactionArray.push(obj);
      });
      Math.floor(new Date().getTime() / 1000);
      const exp = Math.floor(new Date().getTime() / 1000);
      const idsInArray2 = new Set(itemsRows.map((item) => item.attachmentid));

      let arratt = [];
      const updatedArray1 = currentDouments.map((item) => {
        let arr;
        if (!idsInArray2.has(item.attachmentid) && typeof item.attachmentid !== 'string') {
          arr = { ...item, expiredtimestamp: exp };
          arratt.push(arr);
        } else {
          arr = itemsRows.find((att) => att.attachmentid === item.attachmentid);
          arratt.push(arr);
        }
      });

      const additionalItems = itemsRows.filter((item2) => !currentDouments.some((item1) => item1.attachmentid == item2.attachmentid));

      const finalArray = [...arratt, ...additionalItems];
      const attachedArr = finalArray.map((ele) => ({
        attachmentid: typeof ele.attachmentid === 'string' ? 0 : ele.attachmentid,
        crdrnoteid: invoiceEntry?.crdrnoteid,
        documentname: ele.documentname,
        attachmentname: ele.imagename,
        attachmenturl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.imagename.replace('${id}', invoiceEntry?.crdrnoteid)}`,
        type: ele?.type,
        companybranchid: 0,
        expiredtimestamp: ele.expiredtimestamp ? ele.expiredtimestamp : 0,
      }));

      let variables = {
        createCrDrNoteMasterInput: masterData,
        createCrDrNoteDetailsInput: CrDrDetailsData,
        createCrDrNoteLineItemsInput: itemArr,
        createCrDrNoteLineNonItemsInput: nonItemArr,
        createCrDrNoteTDSDetailsInput: [tdsData],
        createCrDrNoteTCSDetailsInput: [tcsData],
        createCrDrNoteDispatchInput: [dispatchData],
        createCrDrAttachmentInput: attachedArr,
        createPartyAddressEntityInput: addressArr,
        createTransactionWithSpecificTimeInput: {
          transactionmaster: [],
          transactiondetails: invTransactionArray,
          transactionrelation: [],
          transactionattachment: [],
          transactiontcsdetails: [],
          transactiontdsdetails: [],
          mode: 0,
        },
      };

      const response = await API.graphql(
        graphqlOperation(
          CreateCrDrBatch,

          variables
        )
      );
      await updatePaymentDetails(response.data?.createCrDrNoteMaster.crdrnoteid);
      if (response.data?.createCrDrNoteMaster.statuscode === 'Error') {
        showWarningSnackbar(response.data?.createCrDrNoteMaster.statusmessage);
      } else {
        if (attachedArr?.length > 0) {
          let responses = itemsRows.map((element) => {
            if (element.file) {
              return uploadToServer(
                element.file,
                element.imagename.replace('${id}', response.data?.createCrDrNoteMaster.crdrnoteid),
                element.type
              );
            }
          });
        }
        await Promise.all(attachedArr);
        showSuccessSnackbar('Debit Note updated successfully');
        dispatch(setNavigationBlocked(false));
        generatePdf(response.data?.createCrDrNoteMaster.crdrnoteid);
        // setShareOpen(url);
        setBackdropOpen(false);
        navigate('/alldebitnote');
      }
    } catch (error) {
      setBackdropOpen(false);
      showErrorSnackbar('Some thing went wrong.Please  try again');
      console.log('error', error);
    }
  }

  async function updatePaymentDetails(invID) {
    try {
      let tranSDetailsArr = [];
      const comments = data.remarks.split('\n');
      if (data.paymentType !== 'Credit') {
        if (paymentTransID !== '') {
          const masterData = {
            transactionid: paymentTransID,
            bankreferencenumber: data.bankReferenceNo,
            entrydate: Math.floor(new Date(data.entryDate).getTime() / 1000),
            comments: comments?.join('**'),
            vouchernumber: data.transactionVoucher,
            serialnumber: data.transactionSeries.value,
            transactiontypecd: data.paymentType == 'Cash' ? 'CashReceipt' : data.paymentType == 'Bank' ? 'BankReceipt' : 'Credit',
            cancelflag: 0,
          };

          paymentTransArr.map((ele, index) => {
            const paymentTransDetails = {
              accountid: ele.accID,
              comments: comments?.join('**'),
              creditamount: Number(ele.creditAmt).toFixed(2),
              debitamount: Number(ele.debitAmt).toFixed(2),
              entryordernumber: index + 1,
              transactionid: paymentTransID,
              transactiontypecd: ele.debitAmt !== 0 ? 'Debit' : 'Credit',
              enteredtimestamp: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
              cancelflag: 0,
            };
            tranSDetailsArr.push(paymentTransDetails);
          });

          const linkCurrentPayment = {
            linkedamount: data.receivedAmount,
            transactiontypecd: 'DebitNote',
            isdirect: 1,
            objectattribute: data.voucherNumber,
            objectid: invID,
            objecttype: data.paymentType,
            transactionid: paymentTransID,
            accountid: partyAccountID,
            paymentvouchernumber: data?.transactionVoucher,
            expiredtimestamp: 0,
          };
          const result = await API.graphql(
            graphqlOperation(createTransactionWithSpecificTime, {
              transactionmaster: JSON.stringify([masterData]),
              transactiondetails: JSON.stringify(tranSDetailsArr),
              transactionattachment: JSON.stringify([]),
              transactiontdsdetails: JSON.stringify([]),
              transactionrelation: JSON.stringify([linkCurrentPayment]),
              mode: 0,
              transactiontcsdetails: JSON.stringify([]),
            })
          );
          let url = path + `Invoices/Receipt/Ledgerx_Receipt_${data.transactionVoucher}.pdf`;
          await createPdf({
            path: url,
            type: 'receipt',
            transactionid: result.data?.createTransactionWithSpecificTime?.transactionid,
          });
        } else {
          savePaymentDetails(invID);
        }
      } else {
        if (paymentTransID !== '' && data?.paymentDeletionFlag === true) {
          const deleteTransMaster = await API.graphql(
            graphqlOperation(deleteTransactionMaster, {
              TransactionID: paymentTransID,
            })
          );
        }
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }
  const [errorArr, setErrorArr] = useState({});
  useEffect(() => {
    let errorKeys = [];
    if (Object.keys(errorArr).length > 0) {
      for (const key in errorArr) {
        if (errorArr[key] === true) {
          errorKeys.push(key);
        }
      }

      if (errorKeys.length > 0) {
        let element = document?.getElementById(errorKeys[0]);

        element?.focus();
      }
    }
  }, [errorArr]);
  useEffect(() => {
    if (tableErrArr.length > 0) {
      let element = document?.getElementById(tableErrArr[0]);

      element?.focus();
    }
  }, [tableErrArr]);
  useEffect(() => {
    let id = 'partyName';
    if (params?.id) {
      getInvoiceMasterData(params?.id);
      setViewMode(params?.view);
    } else {
      setBackdropOpen(false);
    }
    if (!params?.id) {
      let element = document?.getElementById(id);
      element?.focus();
    }
  }, []);
  useEffect(() => {
     if(params?.id){
    if((invoiceEntry && invoiceEntry?.crdrnoteid)){
    getLatestCrDrNote();
    }
    }else{
      getLatestCrDrNote();
    }
  }, [getCompany,data?.seriesVouchers?.value,savedPostingDate]);
   useEffect(()=>{
        if(currentPostingDate){
        setSavedPostingDate(currentPostingDate);
        }
      },[currentPostingDate]);

  function print(htmlOnly) {
    let html = PurchaseTaxablePrint({
      data,
      totGstCess: totGSTCess,
      totGST,
      totNetAmount: Number(netAmountToPay),
      totDiscount,
      totAmount: totAmt,
      tabelTotAmount: totAmt,
      totTaxableAmount: totTaxAmt,
      bankDetails: {},
      registrationType: companyData.relatedcompanydetailsnew?.[0]?.registrationtype,
      suppierAddressDetals: billingAddressDetails,
      companyDetails: companyData,
      nonItems,
      items,
      units,
      nonItemwiseTableAmount: totNetAmt,
      invTransArr: invTransArr,
      // journalhtmlItems,
      // journalhtmlNonItems,
      totGstRate: totGST,
      companyState: companyState,
      stateName: billingAddressDetails.stateCD,
      countryName: billingAddressDetails.countryCD,
      stateOfSupply: billingAddressDetails.districtCD,
      fromType: 'debitNote',
      partyType
    });
    console.log(html);
    if (htmlOnly) {
      return html;
    } else {
      printJS({
        printable: html,
        type: 'raw-html',
      });
    }
  }
  console.log(nonItems);

  const MailIt = async (InvoiceName) => {
    let dataP = {
      items,
      nonItems,
      InvoiceSettings,
      companyDetails: companyData,
      data,
      partyDetails: partyBillAddressEntity,
      // itemEntry,
      // registrationType,
      totGST: totGST,
      totGstCess: totGSTCess,
      totNetAmount: totNetAmt,
      totTaxableAmount: totTaxAmt,
      totAmount: totAmt,
      tabelTotAmount: totAmt,
      nonItemwiseTableAmount: totNetAmt,
      // bankDetails,
      units,
      billingAddressDetails,
      deliveryAddressDetails,
      stateName: billingAddressDetails.stateCD,
      countryName: billingAddressDetails.countryCD,
      stateOfSupply: billingAddressDetails.districtCD,
      companyState: companyState,
    };
    console.log({ dataP });
    let html = SalesTaxablePrint(dataP);
    console.log('3');
    try {
      const option = {
        method: 'POST',
        url: 'https://hotk5j6lmqvviyjqc5jp7y7qh40yczuu.lambda-url.ap-south-1.on.aws/',
        data: JSON.stringify({ html, InvoiceName }),
      };
      return await axios(option);
    } catch (error) {
      setBackdropOpen(false);
      console.log(error);
    }
  };
  const callBackNavigate = () => (isVoucher ? isVoucher(false) : navigate('/alldebitnote'));
  const [shareOpen, setShareOpen] = useState('');
  const [sendEmailData, setSendEmailData] = useState({});
  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);
  const ids = [
    'partyCreationModal',
    'addItemModal',
    'deleteCategory',
    'AddLedger',
    'AddHSNModal',
    'AddTdsTcsOptions',
    'BillingAddressModal',
    'DeliveryAddressModal',
    'SettingsModal',
    'DisplayLineItem',
  ];
  const anyElementExists = () => ids.some((id) => document.getElementById(id) !== null);
  useSaveShortcut(
    params?.id && params?.view !== true
      ? () => {
          if (!anyElementExists()) saveEditChanges();
        }
      : params?.view !== true
      ? () => {
          if (!anyElementExists()) saveChanges({ new: false });
        }
      : undefined
  );
  return (
    <Box className="PageHeight">
      {viewMode === true && invoiceEntry?.cancelflag ? (
        <>
          <Box
            sx={{
              position: 'sticky',
              top: '10px',
              borderRadius: '8px',
              marginBottom: '0px',
              padding: { xs: '10px 0px', sm: '10px 10px' },
              transition: 'all 1s ease-in-out',
            }}
          >
            <Alert
              variant="standard"
              sx={{
                color: invoiceEntry?.cancelflag === 0 ? '' : 'red',
                boxShadow: 'none',
                width: 450,
              }}
              severity="error"
            >
              {invoiceEntry?.cancelflag === 1 ? 'Debit Note cancelled. No further updates can be made.' : null}
            </Alert>
          </Box>
          <Box sx={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '10' }}>
            <CancelUI />
          </Box>
        </>
      ) : null}
      <Box
        className="darkDisabledInputs"
        sx={{
          opacity: viewMode === true && invoiceEntry?.cancelflag ? '0.5' : '1',
          cursor: viewMode === true && invoiceEntry?.cancelflag ? 'no-drop' : 'default',
        }}
      >
        <Box
          sx={{
            borderRadius: '8px',
            // marginBottom: "10px",
            // boxShadow:
            //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            // padding: { xs: "10px 0px", sm: "10px 10px" },
            borderRadius: '8px',
            ':hover': {
              boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
            },
            transition: 'all 1s ease-in-out',
          }}
        >
          <InvoiceBasicDetails
            todayDate={todayDate}
            accountDetails={accountDetails}
            moment={moment}
            invoiceLabels={{
              partyName: 'Customer/Supplier',
              gstINName: 'Customer/Supplier GSTIN',
              seriesName: 'Debit Note Series Name',
              voucherName: 'Debit Note Number',
              voucherValue: 'voucherNumber',
              dateName: 'Debit Note Date',
              seriesValue: 'seriesVouchers',
              voucherType: 'DebitInvoice',
              orderNumberName: 'Customer/Supplier Order Number',
              voucherModalName: 'Debit Note Number Settings',
              orderDateName: 'Customer/Supplier Order Date',
            }}
            partyTypeCD={'CUSTOMERORSUPPLIER'}
            params={params}
            Type="DebitNote"
          />
        </Box>
        <Box
          sx={{
            width: '100%',
            // borderRadius: "12px",
            overflow: 'hidden',
            // marginBottom: "10px",
            mt: 3,
            // boxShadow:
            //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            // ":hover": {
            //   boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
            // },
            transition: 'all 1s ease-in-out',
            '.MuiTableCell-root': {
              padding: '0px 5px',
            },
            '.MuiTableCell-head': {
              borderBottom: '0px',
              fontWeight: 'bold',
            },
          }}
        >
          <Box sx={{ m: 1, marginTop: '0px', marginBottom: '0px', marginLeft: '0px' }}>
            <EntryTable
              Type="DebitNote"
              invoiceLabels={{
                partyName: 'Customer/Supplier Name',
                gstINName: 'Customer/Supplier GSTIN',
                seriesName: 'Debit Note Series Name',
                voucherName: 'Debit Note Number',
                voucherValue: 'voucherNumber',
                dateName: 'Debit Note Date',
                seriesValue: 'seriesVouchers',
                voucherType: 'DebitInvoice',
                orderNumberName: 'Customer/Supplier Order Number',
                voucherModalName: 'Debit Note Number Settings',
                orderDateName: 'Customer/Supplier Order Date',
              }}
              labelNamesOfTcs={{
                tdsOrTcsType: '2',
                amountName: 'Invoice Amount',
                tcsOrTdsName: 'Add TCS if any',
                tcsOrTdsLabel: 'TCS Section',
                tcsOrTdsAmountLabel: 'TCS (%)',
                amountAfterLabel: 'Amount(After TCS)',
              }}
              labelNamesOfTds={{
                tdsOrTcsType: '1',
                amountName: 'Invoice Amount',
                tcsOrTdsName: 'Add TDS if any',
                tcsOrTdsLabel: 'TDS Section',
                tcsOrTdsAmountLabel: 'TDS (%)',
                amountAfterLabel: 'Amount(After TDS)',
              }}
            />
          </Box>
        </Box>
        <Box
          className="custom-scrollbar"
          sx={{
            width: '100%',
            // borderRadius: "12px",
            overflow: 'scroll',
            mt: 3,
            border: { xs: 'none', lg: '1px solid gray' },
            borderColor: 'input.label',

            // marginBottom: "10px",
            // boxShadow:
            //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            // ":hover": {
            //   boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
            // },
            transition: 'all 1s ease-in-out',
            '.MuiTableCell-root': {
              padding: '4px 10px',
            },
            '.MuiTableCell-head': {
              backgroundColor: 'background.tablebg',
              padding: '10px 8px',
              borderBottom: '0px',
              fontSize: '13px',
              fontWeight: 'bold',
            },
          }}
        >
          <Box
            sx={{
              m: 1,
              marginBottom: '0px',
              marginTop: '0px',
              marginLeft: '0px',
              display: 'flex',
              flexWrap: { xs: 'wrap', md: 'wrap' },
              flexDirection: { xs: 'column', lg: 'row' },
            }}
          >
            <HsnandJournalTab Type="DebitNote" />
            <Box
              sx={{
                flex: { xs: 1, lg: 0.5 },
                // m: "5px",
                // border: "1px solid #C9C9C9",
                // borderColor: "input.label",
                border: { xs: 'solid 1px gray', lg: 'none' },
                borderLeft: { lg: '1px solid gray' },
                marginTop: '10px',
                height: partyType == 'SUPPLIER' ? 370 : 290,
                p: '5px',
                overflowX: 'none',
              }}
            >
              <TotalAmountLabels
                labelNamesOfTcs={{
                  tdsOrTcsType: '2',
                  amountName: 'Invoice Amount',
                  tcsOrTdsName: 'Add TCS if any',
                  tcsOrTdsLabel: 'TCS Section',
                  tcsOrTdsAmountLabel: 'TCS (%)',
                  amountAfterLabel: 'Amount(After TCS)',
                }}
                labelNamesOfTds={{
                  tdsOrTcsType: '1',
                  amountName: 'Invoice Amount',
                  tcsOrTdsName: 'Add TDS if any',
                  tcsOrTdsLabel: 'TDS Section',
                  tcsOrTdsAmountLabel: 'TDS (%)',
                  amountAfterLabel: 'Amount(After TDS)',
                }}
                Type="DebitNote"
              />
            </Box>
          </Box>
        </Box>
        {/* <Box
        sx={{
          marginBottom: "10px",
          padding: { xs: "10px 0px", sm: "10px 10px" },
          borderRadius: "12px",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
        }}
      >
        <PaymentDetails
          Enable_CreditPeriod={Enable_CreditPeriod}
          moment={moment}
          paymentType={"Receipt Details"}
          paymentLabels={{
            seriesName: "Receipt Series Name",
            voucherName:
              data.paymentType == "Cash"
                ? "Cash Receipt Number"
                : "Bank Receipt Number",
            voucherValue: "transactionVoucher",
            seriesValue: "transactionSeries",
            voucherType: "Receipt",
            accLabel: "Received To Account (Dr)",
            accNames: "Received To Account",
            amountName: "Received Amount",
            dueDateName: "Debit Note Due Date",
            voucherModalName: "Receipt Number Settings",
          }}
          Type="DebitNote"
          params={params}
        />
      </Box> */}
        <Box
          sx={{
            // marginBottom: "10px",
            padding: { xs: '10px 0px', sm: '0px 0px' },
            borderRadius: '12px',
            // boxShadow:
            //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            // ":hover": {
            //   boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
            // },
            transition: 'all 1s ease-in-out',
          }}
        >
          <DispatchDetails Type="DebitNote" />
        </Box>

        <Grid lg={12} sx={{ marginTop: '16px', marginBottom: '0px' }}>
          <Box
            sx={{
              // marginBottom: "10px",
              padding: { xs: '10px 0px', sm: '0px 0px' },
              // borderRadius: "12px",
              display: 'flex',
              gap: '20px',
              flexDirection: { xs: 'column', md: 'column', lg: 'row' },
            }}
          >
            <Grid
              item
              container
              lg={3}
              xs={12}
              md={12}
              sx={{
                // padding: "0px 10px",
                display: 'flex',
                flexDirection: 'column',
                '.MuiPaper-root': {
                  boxShadow: 'none',
                },
              }}
            >
              <Description labelName="Debit Note Description" Type="DebitNote" />
            </Grid>
            {/* <Grid item container lg={9} xs={12} md={12}> */}
            <MultiFileAttachment Type="DebitNote" />
            {/* </Grid> */}
          </Box>
        </Grid>
      </Box>
      {/* {(viewMode == true ? invoiceEntry.cancelflag === 0 : true) ? ( */}
      <DraggableAction
        actionType={params?.id && params?.view !== true ? 'edit' : invoiceEntry?.cancelflag === 1 ? 'cancelled' : 'save'}
        from={'debit'}
        onExit={() => {
          navigate('/alldebitnote');
        }}
        onSave={
          params?.id && params?.view !== true
            ? () => {
                saveEditChanges();
              }
            : params?.view !== true
            ? () => saveChanges({ new: false })
            : null
        }
        onEnableEdit={() => {
          navigate('/editdebitnote', {
            state: { id: invoiceEntry?.crdrnoteid },
          });
        }}
        onPrint={params?.view == true || params?.id ? () => fetchAndPrintPDF(uri) : null}
        onCancel={
          params?.view == true || params?.id
            ? () => {
                setCancelModalStatus(true);
                setItemData({
                  id: invoiceEntry?.invoiceid,
                  nav: '/alldebitnote',
                  todo: 'cancel',
                  linked: paymentTransID !== '',

                  from: 'debit',
                });
              }
            : null
        }
        onDelete={
          params?.view == true || params?.id
            ? () => {
                setDeleteModalStatus(true);
                setItemData({
                  id: invoiceEntry?.invoiceid,
                  nav: '/alldebitnote',
                  todo: 'delete',
                  linked: paymentTransID !== '',
                  // fn: () => deletePurchaseInvoice(invoiceEntry?.PurchaseID),
                  from: 'debit',
                });
              }
            : null
        }
        onPreview={
          // (params?.view == true || Number.isNaN(params?.id)) && data.partyName.label !== ''
          //   ? () => {
          //       setPreviewSalesTaxableModal(true);
          //     }
          //   : null
          () => {setPreviewSalesTaxableModal(true)}
        }
        onSaveNew={params?.view !== true ? () => saveChanges({ new: true }) : null}
        onReset={
          params?.view !== true
            ? () => {
                if (params?.id) {
                  setData(initialState);
                  setItems(initItemTableDta.length > 0 ? initItemTableDta : [newItemObj]);
                  setNonItems(initNonItemTableData.length > 0 ? initNonItemTableData : [newNonItemObj]);
                  setItemsRows(initialAttachments);
                } else {
                  // setData((prevData) => ({
                  //   ...resetData, // Reset all fields
                  //   transactionVoucher: prevData?.transactionVoucher,
                  //   voucherNumber: prevData?.voucherNumber, // Preserve voucherNumber
                  //   placeOfSupply: prevData?.placeOfSupply, // Preserve placeOfSupply
                  //   seriesVouchers: prevData?.seriesVouchers,
                  //   transactionSeries: prevData?.transactionSeries,
                  //   invoiceDate: prevData?.invoiceDate,
                  //   customerOrderDate: prevData?.customerOrderDate,
                  // }));
                  setData(initialState);
                  setNonItems([resetNonItems]);
                  setItems([resetItems]);
                  setItemValid(true);
                  setNonItemValid(true);
                  setItemsRows([]);
                }
              }
            : null
        }
      />
      {/* ) : null} */}
      {cancelModalStatus == true ? (
        <InvoiceCancel
          state={state}
          setState={setState}
          open={cancelModalStatus}
          setOpen={setCancelModalStatus}
          itemData={itemData}
          data={data}
          setData={setData}
          actionType={'Cancel'}
          invoiceEntry={invoiceEntry}
          transID={paymentTransID}
          invTransArr={invTransArr}
          paymentTransArr={paymentTransArr}
          netAmountToPay={netAmountToPay}
          companyState={companyState}
          Type={'DebitNote'}
          path={url}
        />
      ) : null}
      {deleteModalStatus == true ? (
        <InvoiceCancel
          state={state}
          setState={setState}
          open={deleteModalStatus}
          setOpen={setDeleteModalStatus}
          itemData={itemData}
          data={data}
          setData={setData}
          actionType={'Delete'}
          invoiceEntry={invoiceEntry}
          transID={paymentTransID}
          Type={'DebitNote'}
          path={url}
        />
      ) : null}
      <PreviewSalesTaxable open={previewSalesTaxableModal} setOpen={setPreviewSalesTaxableModal} getHtml={print} />
      <ConfirmCancel open={cancelModal} setOpen={setCancelModal} path="alldebitnote" />

      {shareOpen && <ShareModal open={shareOpen} setOpen={setShareOpen} emailData={{selectedRow: [sendEmailData], type: 'debitNote'}} progress={progress} onClose={callBackNavigate} />}
      <Loader open={backdropOpen} />
    </Box>
  );
}

export default NewDebitNotePrime;
